import type React from "react";

export const ShuttlecockIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 64 64"
      {...restProps}
    >
      <title>Shuttlecock Icon</title>
      <g>
        <path
          d="m13.185 38.11-3.172 3.184 12.712 12.712 3.173-3.183L13.186 38.11zM6.18 45.116a7.46 7.46 0 0 0 0 10.54l2.172 2.172a7.46 7.46 0 0 0 10.54 0l2.332-2.32L8.512 42.794zM21.373 31.318 17.955 27.9l-3.513 8.454 2.14 2.14zM34.83 11.195a4.637 4.637 0 0 0-5.419-6.91 4.585 4.585 0 0 0-2.683 2.567l-7.878 18.93 3.737 3.737zM27.793 34.725l16.066-16.077a4.715 4.715 0 0 0 1.395-3.588 4.814 4.814 0 0 0-8.784-2.48L24.12 31.052zM18.115 40.027l2.183 2.182 5.983-5.983-3.375-3.375zM31.157 41.102l-3.375-3.375-5.983 5.984 2.182 2.182zM25.514 47.426l2.14 2.14 8.454-3.513-3.418-3.418zM32.957 39.888l18.472-12.35c5.62-4.121-.938-12.1-6.069-7.389L29.294 36.226zM59.478 30.892a4.643 4.643 0 0 0-6.665-1.714L34.49 41.422l3.737 3.737 18.93-7.879a4.635 4.635 0 0 0 2.32-6.388z"
          fill={color}
        />
      </g>
    </svg>
  );
};
